import { render, staticRenderFns } from "./TheSeguroMedico.vue?vue&type=template&id=b7420b34&scoped=true&"
import script from "./TheSeguroMedico.vue?vue&type=script&lang=js&"
export * from "./TheSeguroMedico.vue?vue&type=script&lang=js&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7420b34",
  null
  
)

export default component.exports